import { format, formatDistanceToNow, getTime } from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
    const fm = newFormat || "dd MMM yyyy";

    return date ? format(new Date(date), fm) : "";
}

export function fDateTime(date, newFormat) {
    const fm = newFormat || "dd MMM yyyy p";

    return date ? format(new Date(date), fm) : "";
}

export function fTimestamp(date) {
    return date ? getTime(new Date(date)) : "";
}

export function fDateTimeSuffixE(date) {
    return format(new Date(date), "MM/dd/yyyy");
}

export function fDateTimeSuffixS(date) {
    if (!date) return "-";

    return format(new Date(date), "MM/dd/yyyy p");
}

export function fDateTimeSuffixSS(date) {
    return `${ format(new Date(date), "MM/dd/yyyy") } at ${ format(new Date(date), "p") }`;
}

export function formatDateTime(date) {
    if (!date) return "-";
  
    return format(new Date(date), "MM/dd/yyyy HH:mm:ss");
  }

export function fToNow(date) {
    return date
        ? formatDistanceToNow(new Date(date), {
            addSuffix: true
        })
        : "";
}

export function fDateTimeOrderNote(date) {
    return format(new Date(date), "MM/dd/yyyy p");
}

export function fDateHistory(date) {
    return format(new Date(date), "MM/dd/yy");
}

export function fDateStore(date) {
    return format(new Date(date), "MM/dd/yyyy");
}

export function fDateCarrier(date) {
    return format(new Date(date), "yyyyMMdd");
}

export function fDateTrail(date) {
    if (!date) return "";

    return format(new Date(date), "MM/dd");
}

export function fPickupDate(date) {
    if (!date) return "";

    const tempData = date.split("-");

    return `${ tempData[ 1 ] }/${ tempData[ 2 ] }/${ tempData[ 0 ] }`;
}

export function fPickupTime(from, to) {
    if (!from || !to) return "";

    const fromTime = fMilitaryTime(from);
    const toTime = fMilitaryTime(to);

    return `${ fromTime } - ${ toTime }`;
}

export function fScanFormDate(date) {
    if (!date) return "";

    return format(new Date(date), "MM/dd/yyyy p");
}

export function fDateOrder(date) {
    return format(new Date(date), "MM/dd/yyyy");
}

export function fDateShipment(date) {
    return format(new Date(date), "MM/dd/yyyy");
}

export function fDateScanForm(date) {
    if (!date) return "";

    if (typeof date === "string") {
        const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            const [ , year, month, day ] = match;
            return `${ month }/${ day }/${ year }`;
        }
    }

    return format(new Date(date), "MM/dd/yyyy");
}

export function fDateBuyLabelPeriodEnd(date) {
    if (!date) return `XX/XX/XXXX`;

    // return format(new Date(date), 'MM/dd/yyyy');
    return format(new Date(date), "MMMM d, yyyy");
}

export function fDateTask(date) {
    return format(new Date(date), "MM/dd/yyyy p");
}

export function fShipment(data) {
    if (!data) return "";

    const DATE = format(data, "yyyy-MM-dd");
    const TIME = format(data, "HH:mm:ss");
    const TIMEZONE = format(data, "xxx");

    return `${ DATE }T${ TIME }${ TIMEZONE }`;
}

export function fTimeStampToMMM(timestamp) {
    if (!timestamp) return "";

    return format(new Date(timestamp), "MMM");
}

export function fDateOrderCreate(date = new Date()) {
    const yy = String(date.getFullYear()); // "2025"
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // "06"
    const dd = String(date.getDate()).padStart(2, "0"); // "02"
    const hh = String(date.getUTCHours()).padStart(2, "0");
    const min = String(date.getUTCMinutes()).padStart(2, "0");
    const ss = String(date.getUTCSeconds()).padStart(2, "0");

    return `${ yy }-${ mm }-${ dd }T${ hh }:${ min }:${ ss }Z`;
}

export function fPickupUPSData(date) {
    const _date = new Date(date);

    const yyyy = _date.getFullYear();
    const mm = String(_date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始
    const dd = String(_date.getDate()).padStart(2, "0");

    return `${ yyyy }-${ mm }-${ dd }`;
}

export function fPickupUPSTime(date) {
    const _date = new Date(date);

    const hh = String(_date.getHours()).padStart(2, "0");
    const mm = String(_date.getMinutes()).padStart(2, "0");

    return `${ hh }${ mm }`;
}

function fMilitaryTime(input) {
    if (!/^\d{4}$/.test(input)) return "Invalid";

    const hours = parseInt(input.slice(0, 2), 10);
    const minutes = input.slice(2);

    const suffix = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 === 0 ? 12 : hours % 12;

    return `${ displayHours }:${ minutes }${ suffix }`;
}
export function convertUTCToPST(date, isShortYear) {
    const utcDate = new Date(date);
    const pstTime = utcDate.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        year: isShortYear ? '2-digit' : 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });

    // 调整格式为 MM/dd/yyyy HH:mm:ss
    const [datePart, timePart] = pstTime.split(', ');
    const [month, day, year] = datePart.split('/');
    return `${month}/${day}/${year} ${timePart}`;
}